import { render, staticRenderFns } from "./KnowledgeBaseDetailModal.vue?vue&type=template&id=06247fef&scoped=true&"
import script from "./KnowledgeBaseDetailModal.vue?vue&type=script&lang=js&"
export * from "./KnowledgeBaseDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeBaseDetailModal.vue?vue&type=style&index=0&id=06247fef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06247fef",
  null
  
)

export default component.exports